import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

// Components
import HomeComponent from '@/components/HomeComponent'
// Views
import RulesComponent from '@/views/RulesComponent'
import CardComponent from '@/views/CardComponent'
import LoginComponent from '@/views/LoginComponent'
import SignupComponent from '@/views/SignupComponent'
import FormQuestionComponent from '@/views/FormQuestionComponent'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: LoginComponent
    },
    {
      path: '/',
      redirect: LoginComponent
    },
    {
      path: '/login',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignupComponent
    },

    {
      path: '/home',
      name: 'home',
      component: HomeComponent,
      meta: {
        requiresAuth: true,
        index: 0
      }
    },
    {
      path: '/rules',
      name: 'rules',
      component: RulesComponent,
      meta: {
        requiresAuth: true,
        index: 3
      }
    },
    {
      path: '/card',
      name: 'card',
      component: CardComponent,
      meta: {
        requiresAuth: true,
        index: 1
      }
    },
    {
      path: '/proposer-une-question',
      name: 'formQuestion',
      component: FormQuestionComponent,
      meta: {
        requiresAuth: true,
        index: 2
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next('login')
  } else if (!requiresAuth && currentUser) {
    next('home')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js